import { ChartFacade } from '@mode/charts/contract';
import { CompiledField } from '@mode/shared/util-switch';
import { DomainLoader } from './colors-modal.component';
import * as ColorModalHelpers from './colors-modal-helpers';
import { FlamingoTypes } from '@mode/shared/contract-common';
import { Encoding } from '@mode-vegas/vegas';

export class QueryDomainLoader implements DomainLoader {
  constructor(
    private view: FlamingoTypes.ModeView,
    private encoding: Encoding,
    private queryRunToken: string | undefined,
    private vizToken: string,
    private isContinuousUnaggregated: boolean
  ) {}
  fetchDomain(
    chartFacade: ChartFacade,
    currentField: CompiledField,
    onResult: (result: any[]) => void,
    onError: (error: string) => void
  ): void {
    const domain$ = ColorModalHelpers.fetchColorDomain(
      chartFacade,
      currentField,
      this.view,
      this.encoding,
      this.queryRunToken ?? '',
      this.vizToken,
      this.isContinuousUnaggregated
    );

    domain$.subscribe({
      next: (domain) => {
        onResult(domain);
      },
      error: (error) => {
        onError(`Unable to load field values: ${error.message}`);
      },
    });
  }
}
